import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const AddJobVacancy = () => {
  const [input, setInput] = useState({
    title: "",
    job_description: "",
    job_qualification: "",
    job_type: "",
    job_tenure: "",
    job_status: 0,
    company_name: "",
    company_image_url: "",
    company_city: "",
    salary_min: 0,
    salary_max: 0,
  });

  const handleInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    setInput({ ...input, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.post(
        "https://dev-example.sanbercloud.com/api/job-vacancy",
        input,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      );
      alert("Job Vacancy added successfully");
      setInput({
        title: "",
        job_description: "",
        job_qualification: "",
        job_type: "",
        job_tenure: "",
        job_status: 0,
        company_name: "",
        company_image_url: "",
        company_city: "",
        salary_min: 0,
        salary_max: 0,
      });
    } catch (error) {
      console.error("Error adding job vacancy:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-4">
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Job Title</label>
        <input
          id="title"
          type="text"
          name="title"
          value={input.title}
          onChange={handleInput}
          placeholder="Enter job title"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">
          Job Description
        </label>
        <textarea
          id="job_description"
          name="job_description"
          value={input.job_description}
          onChange={handleInput}
          placeholder="Enter job description"
          className="border rounded px-4 py-2 w-full"
          required
          rows="4"
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">
          Job Qualification
        </label>
        <input
          id="job_qualification"
          type="text"
          name="job_qualification"
          value={input.job_qualification}
          onChange={handleInput}
          placeholder="Enter job qualification"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Job Type</label>
        <input
          id="job_type"
          type="text"
          name="job_type"
          value={input.job_type}
          onChange={handleInput}
          placeholder="Enter job type"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Job Tenure</label>
        <input
          id="job_tenure"
          type="text"
          name="job_tenure"
          value={input.job_tenure}
          onChange={handleInput}
          placeholder="Enter job tenure"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Job Status</label>
        <input
          id="job_status"
          type="number"
          name="job_status"
          value={input.job_status}
          onChange={handleInput}
          placeholder="Enter job status"
          className="border rounded px-4 py-2 w-full"
          min={0}
          max={1}
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Company Name</label>
        <input
          id="company_name"
          type="text"
          name="company_name"
          value={input.company_name}
          onChange={handleInput}
          placeholder="Enter company name"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">
          Company Image URL
        </label>
        <input
          id="company_image_url"
          type="text"
          name="company_image_url"
          value={input.company_image_url}
          onChange={handleInput}
          placeholder="Enter company image URL"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Company City</label>
        <input
          id="company_city"
          type="text"
          name="company_city"
          value={input.company_city}
          onChange={handleInput}
          placeholder="Enter company city"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Minimum Salary</label>
        <input
          id="salary_min"
          type="number"
          name="salary_min"
          value={input.salary_min}
          onChange={handleInput}
          placeholder="Enter minimum salary"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-lg font-medium mb-2">Maximum Salary</label>
        <input
          id="salary_max"
          type="number"
          name="salary_max"
          value={input.salary_max}
          onChange={handleInput}
          placeholder="Enter maximum salary"
          className="border rounded px-4 py-2 w-full"
          required
        />
      </div>
      <button
        type="submit"
        className="bg-blue-500 text-white px-4 py-2 rounded"
      >
        Add Job Vacancy
      </button>
    </form>
  );
};

export default AddJobVacancy;
